<template>
	<page-container class="container container-groups no-heading-image no-video" :page="page">
		<main-content>
			<div class="columns column12 align-center">
				<h1>{{ page.title || page.header }}</h1>

				<wysiwyg-content :content="page.content" />
			</div>
		</main-content>

		<section class="events-section">
			<div class="row">
				<div class="columns column12 extra-margin">
					<div v-for="item in eventsData" :key="item.ID" class="event-item">
						<div class="date">
							<h2 v-if="item.dateSubtitle" class="subtitle">{{ item.dateSubtitle }}</h2>
							<div v-else class="filler" />
							<h2>{{ item.date }}</h2>
						</div>
						<div class="content">
							<h2 class="subtitle">&nbsp;</h2>
							<h2>{{ item.header }}</h2>
							<wysiwyg-content :content="item.content" />
						</div>
					</div>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup lang="ts">
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: eventsData } = await useWebsiteFetch<WebsiteEvent[]>('events', {
	query: { language: locale.value },
	key: `${locale.value}/events`,
});

useHead({
	bodyAttrs: {
		class: 'subpage',
	},
});
</script>

<style lang="scss" scoped>
.event-item {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: flex-start;
	border-top: 2px solid #fff;
	width: 100%;
	padding: 30px 0;

	h2 {
		margin: 0 0 5px;
	}

	.date {
		width: 28%;
	}

	.content {
		width: 70%;
	}

	.subtitle {
		font-family: var(--body-font-family);
		text-transform: none;
		font-size: 20px;
		letter-spacing: 2px;
	}

	.filler {
		height: 37px;
	}
}

.extra-margin {
	margin-bottom: 100px;
}

@media (max-width: 900px) {
	.event-item {
		flex-flow: row wrap;
		padding: 10px 0;

		.date {
			width: 100%;
			display: flex;
			flex-flow: row wrap;
			justify-content: flex-start;
			align-items: flex-end;
			border-bottom: 1px solid #fff;
			padding: 0 0 5px;

			h2 {
				margin: 0 10px 0 0;
			}
		}

		.filler {
			display: none;
		}

		.content {
			width: 100%;
		}
	}
}
</style>
